export const CONTENT_TYPE = 'content';
export const OBJECTIVE_TYPE = 'objective';
export const OBJECTIVE_GROUP_TYPE = 'objective-group';
export const CHAPTER_TITLE_TYPE = 'chapter-title';
export const CHAPTER_DESCRIPTION_TYPE = 'chapter-description';
export const TYPES = [CONTENT_TYPE, OBJECTIVE_TYPE, OBJECTIVE_GROUP_TYPE, CHAPTER_TITLE_TYPE, CHAPTER_DESCRIPTION_TYPE];
